/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import {
  ContentWrapper,
  FormAutoGenerated,
  LabelMedium,
  NoContent,
  Wrapper,
  useStyletron,
} from '@visualfabriq/vf-ui-kit';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';

import { requiredField } from 'src/components/UIKitTweaks';
import { PipelineTemplateListItem } from 'src/api-new/bifrost';

type Props = {
  templates: PipelineTemplateListItem[];
  title: string;
  selectedTemplatesIds: Set<string>;
  pipelineNamesSet: Set<string>;
  onSelect: (selectedTemplatesId: Set<string>) => void;
};

export function SelectTemplates(props: Props) {
  const { templates, title, selectedTemplatesIds, pipelineNamesSet, onSelect } = props;
  const [css] = useStyletron();

  const initData = useMemo(
    () => Object.fromEntries(templates.map((template) => [template.id, selectedTemplatesIds.has(template.id)])),
    [templates],
  );

  const fields = useMemo(() => {
    return templates.map<FieldItem>((template) => ({
      field_id: template.id,
      field_desc: template.label,
      data_type: 'boolean',
      is_editable_field: !template.mandatory || pipelineNamesSet.has(template.label),
      ...requiredField,
    }));
  }, [templates]);

  const layout: FormLayoutRow[] = [];
  for (let rowIndex = 0; rowIndex < Math.ceil(fields.length / 2); rowIndex++) {
    const fI = rowIndex * 2;
    //@ts-expect-error AUTOMATICALLY GENERATED PLS FIX
    const row: FormLayoutRow = [{ cols: [2, 3, 6], field: fields[fI].field_id }];
    if (fields[fI + 1]) {
      //@ts-expect-error AUTOMATICALLY GENERATED PLS FIX
      row.push({ cols: [2, 3, 6], field: fields[fI + 1].field_id });
    }
    layout.push(row);
  }

  if (!templates.length) {
    return (
      <ContentWrapper>
        <Wrapper>
          <LabelMedium>{title}</LabelMedium>
          <NoContent message="No templates" />
        </Wrapper>
      </ContentWrapper>
    );
  }

  const handleSelect = (templatesState: Record<string, boolean>) => {
    Object.entries(templatesState).forEach(([key, selected]) => {
      if (selected) {
        selectedTemplatesIds.add(key);
      } else {
        selectedTemplatesIds.delete(key);
      }
    });
    onSelect(new Set(selectedTemplatesIds));
  };

  return (
    <ContentWrapper>
      <Wrapper
        height="100%"
        direction="column"
        className={css({
          overflowY: 'auto',
          overflowX: 'hidden',
        })}
      >
        <div className={css({ position: 'sticky', top: '0', backgroundColor: 'white' })}>
          <LabelMedium>{title}</LabelMedium>
        </div>
        <FormAutoGenerated initData={initData} onDataChange={handleSelect as any} fields={fields} layout={layout} />
      </Wrapper>
    </ContentWrapper>
  );
}
